/* eslint-disable react/prop-types */
import React from 'react';
import { Text, Flex, Box, Hide } from '@qga/roo-ui/components';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { mediaQuery } from 'lib/styledSystem';

export const RoomTypeWrapper = styled(Flex)`
  flex-direction: column;
  flex-wrap: wrap;
  background: ${(props) => (!props.exclusiveOffer ? themeGet('colors.greys.porcelain') : themeGet('colors.white'))};
  border-radius: ${themeGet('radii.default')};
  min-height: 350px;

  ${mediaQuery.minWidth.sm} {
    background: ${themeGet('colors.white')};
    flex-direction: row;
    box-shadow: ${(props) => (props.smallTablet ? 'none' : themeGet('shadows.hard'))};
    margin-bottom: ${themeGet('space.2')};
  }

  ${mediaQuery.minWidth.md} {
    box-shadow: ${themeGet('shadows.hard')};
    padding-bottom: ${(props) => (props.exclusiveOffer ? themeGet('space.10') : 0)};
    margin-bottom: ${(props) => (props.exclusiveOffer ? 0 : themeGet('space.2'))};
  }
`;

export const CheckAvailabilityList = styled(Box)`
  flex-grow: 1;

  ${mediaQuery.minWidth.md} {
    flex-direction: row;
    flex: 1;
  }
`;

// In tablet + desktop, apply spacing to the bottom of all offers for each room, except the last one
export const OffersWrapper = styled(Box)`
  flex-grow: 1;
  width: 100%;

  ${mediaQuery.minWidth.md} {
    flex-direction: row;
  }
`;

export const FullWidthHeader = styled(Hide)`
  flex-basis: 100%;
`;

export const UnavailableMessage = ({ children }) => (
  <Flex alignItems="center" mt={[1, 0]} mb={[2, 0]}>
    <Text fontWeight="bold" fontSize="base" color="orange" mr={4}>
      {children}
    </Text>
  </Flex>
);
